/**
 * Desc:
 * Created Date: Tuesday, September 10th 2024, 6:39:46 pm
 * Author: jim Li
 * -----
 * Last Modified: Tue May 13 2025
 * Modified By: jim Li
 */

export default {
  Tag_Common: {
    Shi: '是',
    Fou: '否',
    QiYon: '啟用',
    TingYon: '停用',
    Fu: '複',
    Dan: '單',
    Nong: '濃',
    DaiRu: '帶入',
    Tian: '天',
    XiaoShi: '小時',
    FenZhong: '分鐘',
    FenZhong_10: '10分鐘',
    FenZhong_15: '15分鐘',
    FenZhong_20: '20分鐘',
    FenZhong_30: '30分鐘',
    FenZhong_60: '60分鐘',
    XuanZe: '選擇',
    Yi: '一',
    Er: '二',
    San: '三',
    Si: '四',
    Wu: '五',
    Liu: '六',
    Ri: '日',
    You: '有',
    Wu_Y: '無',
    Zhou_Yi: '週一',
    Zhou_Er: '週二',
    Zhou_San: '週三',
    Zhou_Si: '週四',
    Zhou_Wu: '週五',
    Zhou_Liu: '週六',
    Zhou_Ri: '週日',
  },
}
